<template>
    <BlinkProject></BlinkProject>
</template>

<script setup>

definePageMeta({
  layout: "blinkproject",
  name: "blink",
});

useHead({
  title: 'Oxbull | Project',
  meta: [
    { name: 'title', content: "Oxbull | Project" },
    { name: 'description', content: "Stay at the forefront of the community by exploring the latest project details." }
  ],
  htmlAttrs: { lang: "en" },
  script:[
    {
      // src: "https://blink-cdn.pages.dev/static/web3-frame.js",
      src: "https://blinks.oxbull.tech/web3-frame.js",
      type: "module",
      crossorigin: "anonymous"
    }
  ]
})

</script>